import { lazy, Suspense } from "react";

// Same lazy-chunk pattern as IncomeChart.js — defers recharts+d3 until after
// hydration.
const MembersChartImpl = lazy(() =>
  import("./MembersChart.impl").then((m) => ({ default: m.MembersChart }))
);

const MembersChart = (props) => (
  <Suspense fallback={null}>
    <MembersChartImpl {...props} />
  </Suspense>
);

export default MembersChart;
